import { render } from "./HomeOfficeCard.vue?vue&type=template&id=466706f4&scoped=true"
import script from "./HomeOfficeCard.vue?vue&type=script&lang=js"
export * from "./HomeOfficeCard.vue?vue&type=script&lang=js"

import "./HomeOfficeCard.vue?vue&type=style&index=0&id=466706f4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-466706f4"]])

export default __exports__